import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LoaderLinear } from '@agronod/mui-components';
import { useOidcUser } from '../utils/hooks';
import AppLayout from './AppLayout';
import KundvalPage from '../pages/Kundval/KundvalPage';
import RevisionPage from '../pages/Revision/RevisionPage';
import RevisionRevealedPage from '../pages/Revision/RevisionRevealedPage';
import GardDetaljPage from '../pages/Revision/GardDetaljPage';

const REVISION = '/kund/:kundId/ar/:ar/:inriktning/revision';

const Router = () => {
  const { oidcUser, isLoading } = useOidcUser();

  if (isLoading || !oidcUser) {
    return <LoaderLinear color="primary" isGlobal={true} />;
  }

  return (
    <BrowserRouter>
      <AppLayout>
        <Routes>
          <Route path="/" element={<KundvalPage />} />
          <Route path={REVISION} element={<RevisionPage />} />
          <Route
            path={`${REVISION}/gard/:nummer`}
            element={<GardDetaljPage kalla="list" />}
          />
          <Route
            path={`${REVISION}/avpseudonymiserade`}
            element={<RevisionRevealedPage />}
          />
          <Route
            path={`${REVISION}/avpseudonymiserade/gard/:nummer`}
            element={<GardDetaljPage kalla="revealed" />}
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
};

export default Router;
